import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import FakePainters from './FakePainters'
import RealUsers from './RealUsers'
import PermissionManagement from './PermissionManagement'
import { useTabQuery } from 'hooks/useQueryState'

const PublishersTable = () => {
  const [tab, setTab] = useTabQuery('pubTab', 'painter')
  return (
    <Tabs value={tab} onValueChange={setTab} className="flex-1 space-y-4">
      <div className="flex items-center gap-8">
        <h2 className="text-3xl font-bold tracking-tight">Painters</h2>
        <TabsList>
          <TabsTrigger value="painter">Painters</TabsTrigger>
          <TabsTrigger value="user">Admins / Designers</TabsTrigger>
          <TabsTrigger value="permissions">权限管理</TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="painter" className="space-y-4">
        <FakePainters />
      </TabsContent>
      <TabsContent value="user" className="space-y-4">
        <RealUsers />
      </TabsContent>
      <TabsContent value="permissions" className="space-y-4">
        <PermissionManagement />
      </TabsContent>
    </Tabs>
  )
}

export default PublishersTable
